import { notification } from 'antd'
import Quill from 'quill'
import { inlineImageRejectionReason, isTooLargeEncoded, scaledDimensions } from './inlineImageModel'

const toScaledDataUrl = (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onerror = () => reject(new Error('Could not read that file.'))
  reader.onload = () => {
    const image = new Image()
    image.onerror = () => reject(new Error('Could not read that image.'))
    image.onload = () => {
      const { width, height } = scaledDimensions(image.width, image.height)
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const context = canvas.getContext('2d')
      if (context === null) {
        reject(new Error('Could not resize that image.'))
        return
      }
      context.drawImage(image, 0, 0, width, height)
      resolve(canvas.toDataURL(file.type === 'image/png' ? 'image/png' : 'image/jpeg', 0.82))
    }
    image.src = reader.result as string
  }
  reader.readAsDataURL(file)
})

export const insertInlineImage = (quill: Quill) => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/png,image/jpeg,image/gif,image/webp'
  input.onchange = async () => {
    const file = input.files?.[0]
    if (file === undefined) {
      return
    }
    const rejection = inlineImageRejectionReason(file)
    if (rejection !== undefined) {
      notification.error({ message: rejection })
      return
    }
    try {
      const dataUrl = await toScaledDataUrl(file)
      if (isTooLargeEncoded(dataUrl)) {
        notification.error({ message: `${file.name} is still too large after resizing. Try a smaller image.` })
        return
      }
      const range = quill.getSelection(true)
      quill.insertEmbed(range?.index ?? quill.getLength(), 'image', dataUrl, 'user')
    } catch (error) {
      notification.error({ message: (error as Error).message })
    }
  }
  input.click()
}
